import "./index.scss";
import React from "react";

import Layout1 from "./Layout1/Layout1";
import Default from "./Default/Default";

class DatePicker extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {props} = this;

        if(props.layout === "layout1") {
            return <Layout1 {...props} />
        }

        return (
            <Default {...props} />
        );
    }
}

DatePicker.defaultProps = {
    layout: "default"
}

export default DatePicker;